import { render } from "./behno-world-hero.vue?vue&type=template&id=445aec91&scoped=true"
import script from "./behno-world-hero.vue?vue&type=script&lang=js"
export * from "./behno-world-hero.vue?vue&type=script&lang=js"

import "./behno-world-hero.vue?vue&type=style&index=0&id=445aec91&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445aec91"]])

export default __exports__